module.exports = __webpack_public_path__ + "img/arrow-left.cb86cd12.svg";